var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoubleRightThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-double-right-thick_svg__clip0_5529_1609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.166 15.827a.96.96 0 01-.24-1.334l4.387-6.313a.313.313 0 000-.367L7.926 1.507a.953.953 0 01.24-1.334.947.947 0 011.334.24l4.393 6.307a2.253 2.253 0 010 2.56L9.5 15.587a.96.96 0 01-1.334.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02.593L9.406 6.9a1.94 1.94 0 010 2.193L5.02 15.407a.667.667 0 01-.527.273h-2.14a.667.667 0 01-.573-.347.667.667 0 01.046-.666L6.213 8.36a.667.667 0 000-.733L1.826 1.333A.667.667 0 011.78.667.667.667 0 012.353.32h2.14a.667.667 0 01.527.273z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-double-right-thick_svg__clip0_5529_1609"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconDoubleRightThick;